/**
 * Registro de componentes de interfaz que un paquete puede seleccionar (F2.5,
 * plan maestro §6.2).
 *
 * Un paquete NUNCA trae codigo: elige de esta lista cerrada, y la interfaz solo
 * pinta lo que conoce. Un componente nuevo se programa, se revisa y se agrega
 * aqui; no llega por configuracion.
 */
export const COMPONENTES_DE_INTERFAZ = [
    // Nucleo
    'resumenClinico',
    'signosVitales',
    'graficaObservaciones',
    'listaProblemas',
    'listaAlergias',
    'listaMedicacion',
    'lineaDeTiempo',
    // Ginecologia y colposcopia (los modelos existentes, F2.7)
    'historiaGinecologica',
    'colposcopia',
    'galeriaColposcopia',
    // Estudios
    'bandejaResultados',
    'comparadorEstudios',
    'visorDocumento',
    // Nutricion y seguimiento
    'planAlimentacion',
    'graficaSeguimiento',
    // Oftalmologia (F6.1)
    'comparacionPorOjo',
    // Otorrinolaringologia (F6.2)
    'audiometriaPorOido',
    // Gastroenterologia (F6.3)
    'procedimientoEndoscopico',
];
/** Tipos de estudio que un paquete puede declarar (los usa STUDY-01, F3.4). */
export const TIPOS_DE_ESTUDIO = [
    'citologia',
    'vph',
    'biopsia',
    'ecg',
    'ecocardiograma',
    'holter',
    'mapa',
    'laboratorio',
    'imagen',
    // Oftalmologia (F6.1): se guardan como originales, sin analisis.
    'oct',
    'fondo-de-ojo',
    'campimetria',
    // Otorrinolaringologia (F6.2): originales; la audiometria, ademas, estructurada.
    'audiometria',
    'timpanometria',
    'endoscopia-orl',
    // Gastroenterologia (F6.3): procedimientos y el resultado de patologia.
    'endoscopia-digestiva-alta',
    'colonoscopia',
    'patologia',
];
/**
 * Estudios que son de UN lado: registrarlos exige decir cual (F6.1). Una OCT
 * del ojo izquierdo archivada como del derecho es el error que se evita aqui.
 */
export const TIPOS_DE_ESTUDIO_CON_LADO = [
    'oct',
    'fondo-de-ojo',
    'campimetria',
];
export const NOMBRE_DE_TIPO_DE_ESTUDIO = {
    citologia: 'Citología',
    vph: 'VPH',
    biopsia: 'Biopsia',
    ecg: 'Electrocardiograma',
    ecocardiograma: 'Ecocardiograma',
    holter: 'Holter',
    mapa: 'MAPA',
    laboratorio: 'Laboratorio',
    imagen: 'Imagen',
    oct: 'OCT',
    'fondo-de-ojo': 'Fondo de ojo',
    campimetria: 'Campimetría',
    audiometria: 'Audiometría',
    timpanometria: 'Timpanometría',
    'endoscopia-orl': 'Endoscopía ORL',
    'endoscopia-digestiva-alta': 'Endoscopía digestiva alta',
    colonoscopia: 'Colonoscopía',
    patologia: 'Patología',
};
/**
 * Documentos que ya existian antes de los paquetes y que un paquete puede
 * envolver sin reescribirlos ni cambiar su firma (plan §13.2, F2.7).
 */
export const DOCUMENTOS_EXISTENTES = [
    'historia-clinica',
    'colposcopia',
    'receta',
    'nota-evolucion',
    'nota-egreso',
    'nota-aclaratoria',
];
//# sourceMappingURL=componentes.js.map